import { render } from "./ServiceContent.vue?vue&type=template&id=d45da622&scoped=true&ts=true"
import script from "./ServiceContent.vue?vue&type=script&lang=ts"
export * from "./ServiceContent.vue?vue&type=script&lang=ts"

import "./ServiceContent.vue?vue&type=style&index=0&id=d45da622&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45da622"]])

export default __exports__